// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__8EgfA","spin":"Loading_spin__WzegH","center_loader":"Loading_center_loader__aBmaD"};